/* globals jQuery */

import { debounce } from 'throttle-debounce'

/**
 * jQueryResponsiveNav module
 *
 * Usage:
 *
 * ```js
 * $.fn.responsiveNav = require('./responsive-nav.jquery.js')
 *
 * $('.my-nav-element').responsiveNav({ options })
 * ```
 */
export default (($) => {

return function jQueryResponsiveNav( options ) {

    options = $.extend({}, {
        wrapperSelector: '.site-wrapper',
        menuButtonSelector: '.menu-btn',
        menuOpenWrapperClass: 'menu-open',
        activeClass: 'active',
        debounceTime: 150,
    }, options);

    const $this = $(this),
        $wrapper = $( options.wrapperSelector ),
        $menuButton = $( options.menuButtonSelector ),
        $closeButton = $('.main-nav__close');

    function _menuIsOpen() {
        //site wrapper has the menu-open class
        return $menuButton.hasClass( options.activeClass );
    }

    /*
    * CLOSE MOBILE NAVIGATION
    */
    function closeNav() {
        $wrapper.removeClass( options.menuOpenWrapperClass );
        $menuButton.removeClass( options.activeClass ).focus();
        $menuButton.attr("aria-expanded", "false");
        // hide close menu link
        $menuButton.find('.screen-reader-text').html('Menu');
    }

    /*
    * OPEN MOBILE NAVIGATION
    */
    function openNav() {
        $wrapper.addClass( options.menuOpenWrapperClass );
        $menuButton.addClass( options.activeClass );
        $menuButton.attr("aria-expanded", "true");
        $menuButton.find('.screen-reader-text').html('Close Menu');

        // show the close menu button & set focus to it
        $('.main-nav__close').focus();

        if (options.closeOnOutsideClick) {
            // close the menu when the user clicks anywhere outside it
            $(options.wrapperSelector).on('touchstart, click', function _onOutsideClick(evt) {
                //if not nav container or a decendant of nav container
                if( !$this.is(evt.target) && $this.has(evt.target).length === 0 ) {
                    closeNav();
                }
            });
        }

        //capture looped tabbing in the mobile menu if it is open
        $wrapper.on("keydown", function(event){
            if( _menuIsOpen() && $(event.target).is($menuButton) && event.key == 'Tab' && event.shiftKey ) {
                //if keydown target is the menuButton, keyused is shift+tab, focus the bottom close button
                event.preventDefault();
                $closeButton.focus();
            } else if( _menuIsOpen() && $(event.target).is($closeButton) && event.key == 'Tab' && !event.shiftKey ) {
                 //if keydown target is on the bottom close button, keyused is tab (not with shift), focus the top close button
                event.preventDefault();
                $menuButton.focus();
            }
        })//end tabbing capture
    }//end openNav

    //ARIA LABLES - when mobile menu
    function setAriaLables(){
        //if mobile view, add modal attributes to menu for ADA
        if( $menuButton.is(':visible') ) {
            $this.attr("role", "navigation").attr("aria-label", "Main Navigation Menu");
        }
        else{
            $this.removeAttr("role").removeAttr("aria-label");
        }
    }

    //TOGGLE FUNCTIONALITY
    $(options.wrapperSelector).on('touchstart, click', function(evt) {
        //if not menu-item or a decendant of nav container
        if( !$('nav.main-nav > ul > li.menu-item').is(evt.target) && $('nav.main-nav > ul > li.menu-item').has(evt.target).length === 0 ) {
            console.log('close dropdown');
            $('.toggle-only').attr('aria-expanded', 'false');
            $('.toggle-only').next('.main-nav__second').removeClass('tab-show');

        }
    });

    // Toggling for main navigation
    $('nav.main-nav > ul > li.menu-item > a.toggle-only').on('click', function (e) {

        if( $(this).next('.main-nav__second').hasClass('tab-show') ){
            console.log('close dropdown');
            $(this).attr('aria-expanded', "false");
            $(this).next('.main-nav__second').removeClass('tab-show');
        }
        else{
            console.log('show dropdown');
            //add tab show to this dropdown
            $(this).next('.main-nav__second').addClass('tab-show');
            $(this).attr('aria-expanded', "true");

            //get all other menu items that are toggles and close its dropdown
            $(this).closest('.menu-item').siblings('.menu-item-has-children').find('.toggle-only').attr('aria-expanded', "false");
            $(this).closest('.menu-item').siblings('.menu-item-has-children').find('.main-nav__second').removeClass('tab-show');
            
        }

    });

    //MOBILE NAV TOGGLES
    const sublevelNav = function() {
		$this.find('.main-nav__dropper').each(function(){
			$(this).on('touchstart, click', function(event) {

				event.stopPropagation();
				event.preventDefault();

				//if menu is open and the subnav is not visible and subnav exists
				if ( _menuIsOpen() && !$(this).parent().next().is(':visible') && $(this).parent().next().length > 0) {

					//close what's already open at the same level
					//remove toggle class from the li and slide up its child ul
					$(this).parent().parent().siblings().removeClass('toggle').children('.main-nav__second').slideUp(250);

					//expand current click
					$(this).parent().parent().addClass('toggle');
					$(this).parent().next('.main-nav__second').slideDown(250);

				}
				else if ( _menuIsOpen() && $(this).parent().next('.main-nav__second').is(':visible') ) {
						//close this item
						$(this).parent().parent().removeClass('toggle');
						$(this).parent().next('.main-nav__second').slideUp(250);
				}

			}); //end bind
		});//end find span.dropper
	};//end sublevelNav

    const activeToggleFn = function(){
        //on mobile check for active navigation and set open accordingly
        if( $menuButton.is(':visible') ){

            $this.find('ul.main-nav__menu li.current_page_item, ul.main-nav__menu li.current-menu-ancestor').each(function(){
                if( !$(this).hasClass('toggle') ){
                    $(this).addClass('toggle');
                }
                if( !$(this).children('.main-nav__second').is(':visible') ){
                    $(this).children('.main-nav__second').show();
                }
            });
        }
    } //end activeToggleFn

    $menuButton.on( 'touchstart, click', function(event) {

        event.stopPropagation();
        event.preventDefault();

        if ( _menuIsOpen() ) {
            closeNav();
        }
        else{
            openNav();
        }
    }) //end button on

    $('.main-nav__close').on('click',function(){
        closeNav();
    });

    sublevelNav();
    activeToggleFn();
    setAriaLables();


    $(window).on('resize', debounce(options.debounceTime, function() {

        setAriaLables();

        if( !$menuButton.is(':visible') ) {
            //close mobile menu
            if ( _menuIsOpen() ) {
                //closeNav() - we dont want to run the function cause we dont want all transitions with the dropdown
                $menuButton.removeClass( options.activeClass );
                $wrapper.removeClass( options.menuOpenWrapperClass );
                $this.removeAttr('style');
            }
            //remove any inline styles from subnavigation
            $this.find( 'ul, .main-nav__second' ).removeAttr( 'style' );
            $this.find('.menu-item-has-children').removeClass('toggle');
            $this.removeAttr('style');
        }
        else{
            activeToggleFn();
        }

    }));

    

    return this;
}

})(jQuery)
